import _ from 'underscore'
import React from 'react'
import { useParams } from 'react-router-dom'

import TrendForm from 'pages/shared/TrendForm'

import useTrends from 'hooks/useTrends'
import { useStoreContext } from 'hooks/StoreContext'

import { LoadingSinglePanePage, SinglePanePage } from 'styles/shared'

const EditTrend = () => {
  useTrends()

  const { trends, areTrendsLoaded } = useStoreContext()

  const { id } = useParams()
  if (!areTrendsLoaded) {
    return <LoadingSinglePanePage />
  }

  return (
    <SinglePanePage>
      <TrendForm
        title="Edit Trend"
        saveMethod="update"
        trend={_.find(trends, trend => trend.id.toString() === id)}
      />
    </SinglePanePage>
  )
}

export default EditTrend
